<script>
import {mapGetters, mapState} from "vuex";
import TheEditAvatarDialog from "../../Dialogs/TheEditAvatarDialog.vue";
import _ from "lodash";

export default {
  name: "TheAvatarPortfolio",

  data() {
    return {
      editDialogShow: false,
    };
  },

  components: {
    TheEditAvatarDialog,
  },

  computed: {
    ...mapState({
    }),

    ...mapGetters({
      shortNamePerson: "portfolio/shortNamePerson",
      urlPhotoPortfolio: "portfolio/urlPhotoPortfolio",
      groupStudent: "portfolio/groupStudent",
    }),

    sizeAvatar() {
      return this.$vuetify.breakpoint.mobile ? 80 : 100;
    },

    showGroupSubtitle() {
      return !_.isNil(this.groupStudent)
    },

  },

  methods: {
    openProfileEdit() {
      this.editDialogShow = true;
    },
  },
}
</script>

<template>
  <div>
    <v-card-title>
      <v-list-item :class="{'mobile--avatar': $vuetify.breakpoint.mobile}">
        <v-list-item-avatar
          :size="sizeAvatar"
          style="border: 2px #e2e2e2 solid"
        >
          <v-img
            :src="urlPhotoPortfolio"
            container
          />
        </v-list-item-avatar>
        <v-list-item-content :class="{'text-center': $vuetify.breakpoint.mobile}">
          <v-list-item-title class="title">
            {{ shortNamePerson }}
            <v-btn small icon @click="editDialogShow=true">
              <v-icon class="text-center" small >fa-edit</v-icon>
            </v-btn>
          </v-list-item-title>
          <v-list-item-subtitle v-show="showGroupSubtitle">Студент {{groupStudent}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-title>

    <the-edit-avatar-dialog @close="editDialogShow = false" :dialog="editDialogShow"/>
  </div>
</template>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  opacity: .6;
  z-index: 999;
  position: absolute;
  width: 100%;
  background: #222222;
  box-shadow: 0 0 5px 10px #222222;
}

.mobile--avatar {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  flex-basis: auto;
  flex-shrink: 0;
}
</style>